export const environment = {
    production: true,
    oidcClientId: 'odbs-ui',
    clusterEnv: window.config.clusterEnv,
    oidcSwitch: false,
    backend: {
        apiHost: `${window.config.apiHost}${window.config.apiContext}`,
    },
    bahfV6Webcomponent: window.config.bahfV6Webcomponent,
    oidcWebComponent: window.config.oidcWebComponent,
    zweiFaktorWebComponent: window.config.zweiFaktorWebComponent,
    zweiFaktorLink: window.config.zweiFaktorLink,
    oidcRedirectUri: window.config.oidcRedirectUri,
    matomo: {
        enabled: window.config.matomoActive,
        baseUrl: window.config.matomoUrl,
        siteId: window.config.matomoSiteId,
    },
    uiHost: window.config.uiHost,
    oiamAuthority: window.config.oiamAuthority
};
